import React, { useEffect, useState } from 'react';

const PRELOADER_DELAY_MS = 1500;

const Preloader = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, PRELOADER_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          {/* Logo animado */}
          <div className="w-32 h-32 mx-auto mb-8">
            <div className="animate-pulse">
              <svg viewBox="0 0 100 100" className="w-full h-full">
                <text
                  x="50"
                  y="60"
                  fontSize="48"
                  fontWeight="bold"
                  textAnchor="middle"
                  fill="#D4AF37"
                  className="font-inter"
                >
                  ABR
                </text>
              </svg>
            </div>
          </div>

          {/* Loading bar */}
          <div className="w-64 h-1 bg-zinc-800 rounded-full overflow-hidden mx-auto">
            <div className="h-full bg-[#D4AF37] rounded-full preloader-bar"></div>
          </div>

          <p className="text-gray-400 mt-6 text-sm">Carregando...</p>
        </div>
      </div>
    </div>
  );
};

export default Preloader;
